import { Injectable } from "@angular/core";
import { HttpRequestService } from "./http/http-request.service";
import { HttpHeaders } from "@angular/common/http";
import { Constants } from "../helpers/constants";
import { DataService } from "./data/data.service";

@Injectable({ providedIn: "root" })
export class NotificationService {
  constructor(
    private dataService: DataService,
    private httpRequestService: HttpRequestService,
  ) {}

  private authHeaders(): HttpHeaders {
    const token = this.dataService.getToken();
    return new HttpHeaders().set("Authorization", `Bearer ${token}`);
  }

  private buildQuery(filters: any = {}): string {
    const params = new URLSearchParams();
    for (const key in filters) {
      if (filters.hasOwnProperty(key)) {
        const value = filters[key];
        if (value !== null && value !== undefined && value !== "") {
          params.append(key, value);
        }
      }
    }
    const qs = params.toString();
    return qs ? `?${qs}` : "";
  }

  async list(filters: any = {}): Promise<any> {
    const qs = this.buildQuery(filters);
    const urlPath = `${Constants.getUrlPath()}notifications${qs}`;
    return this.httpRequestService.executeRequest(urlPath, this.authHeaders(), "get");
  }

  async unreadCount(): Promise<any> {
    const urlPath = `${Constants.getUrlPath()}notifications/unread-count`;
    return this.httpRequestService.executeRequest(urlPath, this.authHeaders(), "get");
  }

  async markRead(id: string): Promise<any> {
    const urlPath = `${Constants.getUrlPath()}notifications/${id}/read`;
    return this.httpRequestService.executeRequest(urlPath, this.authHeaders(), "post");
  }

  async markAllRead(): Promise<any> {
    const urlPath = `${Constants.getUrlPath()}notifications/read-all`;
    return this.httpRequestService.executeRequest(urlPath, this.authHeaders(), "post");
  }

  async permissions(): Promise<any> {
    const urlPath = `${Constants.getUrlPath()}notifications/permissions`;
    return this.httpRequestService.executeRequest(urlPath, this.authHeaders(), "get");
  }
}
